/* ------------------------------------------------------------------
   ol-priv-form.js — Submit handler pour form Privatisation.
   Submit -> fetch Worker (qui envoie mail client + mail commercial via Resend).
   Pas de Shopify form natif : tout passe par le Worker.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-priv-form');
  if (!sections.length) return;

  function initSection(section) {
    const workerUrl = section.getAttribute('data-worker-url');
    if (!workerUrl) {
      console.warn('[ol-priv-form] data-worker-url manquant. Form desactive.');
      return;
    }

    const form = section.querySelector('[data-form-priv]');
    if (!form) return;

    const submitBtn = form.querySelector('[data-form-submit]');
    const submitLabel = form.querySelector('[data-form-submit-label]');
    const submitLoading = form.querySelector('[data-form-submit-loading]');
    const successEl = section.querySelector('[data-form-status="success"]');
    const errorEl = section.querySelector('[data-form-status="error"]');

    function setLoading(loading) {
      if (!submitBtn) return;
      submitBtn.disabled = loading;
      if (submitLabel) submitLabel.hidden = loading;
      if (submitLoading) submitLoading.hidden = !loading;
    }

    function hideStatus() {
      if (successEl) successEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }

    function showSuccess() {
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function showError() {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      hideStatus();

      const fd = new FormData(form);
      const payload = {
        source: 'privatisation',
        email: (fd.get('contact[email]') || '').toString().trim(),
        name: (fd.get('contact[name]') || '').toString().trim(),
        event_type: (fd.get('contact[event_type]') || '').toString().trim(),
        location: (fd.get('contact[location]') || '').toString().trim(),
        personnes: (fd.get('contact[participants]') || '').toString().trim(),
        dates: (fd.get('contact[dates]') || '').toString().trim(),
        message: (fd.get('contact[body]') || '').toString().trim(),
      };

      if (!payload.email || !payload.name) {
        showError();
        return;
      }

      setLoading(true);

      try {
        const resp = await fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(payload),
        });
        const result = await resp.json().catch(() => ({}));
        const ok = resp.status === 200 || (resp.status === 207 && result.ok);
        if (ok) {
          showSuccess();
          form.reset();
        } else {
          console.warn('[ol-priv-form] worker error', resp.status, result);
          showError();
        }
      } catch (err) {
        console.warn('[ol-priv-form] fetch exception', err);
        showError();
      } finally {
        setLoading(false);
      }
    });
  }

  sections.forEach(initSection);
})();
